import { render } from "./WecomLoginSuccess.vue?vue&type=template&id=cb15df04&scoped=true"
import script from "./WecomLoginSuccess.vue?vue&type=script&lang=js"
export * from "./WecomLoginSuccess.vue?vue&type=script&lang=js"

import "./WecomLoginSuccess.vue?vue&type=style&index=0&id=cb15df04&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb15df04"]])

export default __exports__